import * as React from 'react'

import type { ShiftVersionHistories } from 'modules/attendance/store/collections/shiftVersionHistories'

const Context = React.createContext<ShiftVersionHistories | null>(null)

export const ShiftVersionHistoriesProvider = ({
  collection,
  children,
}: {
  collection: ShiftVersionHistories
  children: React.ReactNode
}) => <Context.Provider value={collection}>{children}</Context.Provider>

export const useShiftVersionHistories = (): ShiftVersionHistories => {
  const shiftVersionHistories = React.useContext(Context)

  if (!shiftVersionHistories) {
    throw new Error('useShiftVersionHistories must be used within a ShiftVersionHistoriesProvider')
  }

  return shiftVersionHistories
}
